import { Inject } from '@angular/core';
import { HttpResponse, HttpRequest, HttpClient, HttpHeaders } from '@angular/common/http';
import { IRESTConfig, RESTConfig } from './RESTConfig';
import { ITokenStore } from './ITokenStore';
import { Observable } from 'rxjs';

export class CookieTokenStore implements ITokenStore {
	refreshRequest(client: HttpClient): Observable<HttpResponse<string>> {
		return client.post(
			`${this.config.baseURL}/${this.config.oauthNode}`,
			{
				grant_type: 'refresh'
			}, {
				// PORK: è in corso per questo use-case l'implementazione ufficiale
				// nel frattempo abuso a porco degli headers.
				headers: new HttpHeaders().set('Authorization', ''),
				withCredentials: true,
				observe: 'response',
				responseType: 'text'
			}
		);
	}

	constructor(
		@Inject( RESTConfig ) private config: IRESTConfig
	) { }

	get userInfo(): string {
		return localStorage.getItem('angular-rest.tokenStore.userInfo') || '{}';
	}

	tokenUpdated(responseText: HttpResponse<string>): void {
		const trimmedBody = (responseText.body || '').trim();
		if (trimmedBody) {
			localStorage.setItem('angular-rest.tokenStore.userInfo', trimmedBody);
		}
	}

	statusChanged(): void {
		// NOOP
	}

	setupRequest(request: HttpRequest<any>): HttpRequest<any> {
		return request.clone({ withCredentials: true });
	}

	/**
	 * Effettua il logout. Il logout è una operazione che deve essere effettuata
	 * lato browser, per questioni di sicurezza. Per questa ragione, la app
	 * viene chiusa nel momento in cui si tenta un logout. (E riaperta a logout
	 * effettuato, tramite un redirect HTTP[S])
	 *
	 * @memberof CookieTokenStore
	 */
	logout(): void {
		localStorage.removeItem('angular-rest.tokenStore.userInfo');
		document.location.href =
			`${this.config.baseURL}/${this.config.oauthNode}?redirect=${encodeURI(document.location.origin + '/login')}`;
	}
}



// WEBPACK FOOTER //
// ./src/app/angular-rest/CookieTokenStore.ts